var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-message def-status-message",class:`status-message--${_vm.variant}`,attrs:{"id":_vm.id,"role":_vm.computedRole,"aria-live":_vm.computedAriaLive,"aria-atomic":_vm.ariaAtomic}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }